import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { MenuItems } from './menu-items/menu-items';
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';
import { CcAccordionComponent } from './cc-accordion/cc-accordion.component';
import { HeaderComponent } from './header/header.component';
import { AngularMaterialModule } from './../angular-material-module';
import { Ng2SmartTableModule } from "ng2-smart-table";
import { SmartTableComponent } from './smart-table/smart-table.component';
import { DialogComponent } from './dialog/dialog.component';
import { MessageDialogComponent } from './message-dialog/message-dialog.component'
import { CommunicationService } from './services/communication.service';
import { LoaderComponent } from './loader/loader.component';
import { DatePipe } from '../util/pipes/date.pipe';
import { CareRewardsComponent } from './../my-care-rewards/care-rewards/care-rewards.component';
import { TemplateComponent } from './template/template.component';
import { UnauthorizedComponent } from '../authentication/unauthorized/unauthorized.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AvatarModule } from 'ngx-avatar';

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CcAccordionComponent,
    HeaderComponent,
    SmartTableComponent,
    DialogComponent,
    MessageDialogComponent,
    LoaderComponent,
    DatePipe,
    CareRewardsComponent,
    TemplateComponent,
    UnauthorizedComponent
  ],
  imports:[
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    Ng2SmartTableModule,
    NgxSkeletonLoaderModule,
    AvatarModule
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    HeaderComponent,
    SmartTableComponent,
    MessageDialogComponent,
    LoaderComponent,
    DatePipe,
    CareRewardsComponent,
    TemplateComponent,
    UnauthorizedComponent,
    AvatarModule
  ],
  providers: [MenuItems, CommunicationService],
  entryComponents: [DialogComponent, MessageDialogComponent]
})
export class SharedModule {}
